var isTouchDevice = function () {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export { isTouchDevice };
//# sourceMappingURL=touchDevice.js.map
